import { Directive } from '@angular/core';
import { AbstractControlOptions, Validators } from '@angular/forms';
import { AuthentificationService } from '@app/authentification/authentification.service';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

@Directive()
export abstract class EaJustifsFormBuilder extends PrFormAbstract {
  isConsultant: boolean;

  constructor(
    protected formConstructor: PrFormConstructor,
    protected authenticationService: AuthentificationService,
  ) {
    super(formConstructor);
    authenticationService.isConsultant().subscribe(consultant => {
      this.isConsultant = consultant;
    });
  }

  generate(entity: any) {
    let options: AbstractControlOptions = {};

    return this.formBuilder.group(
      {
        ownerIds: [
          entity ? entity.ownerIds : null,
          [
            this.prFormService.RefreshEveryValidators(['category']),
            Validators.required,
          ],
        ],

        label: [
          entity ? entity.label : null,
          this.prFormService.AddValidatorsBasedOnCondition(
            this.prFormService
              .isTargetControlValueEqualTo('category', val =>
                ['OTHER'].includes(val),
              )
              .bind(this),
            Validators.required,
          ),
        ],

        document: [
          entity ? entity.document : null,
          [
            this.prFormService.RefreshEveryValidators([
              'dateExpired',
              'documentType',
            ]),
            this.prFormService.AddValidatorsBasedOnCondition(
              this.prFormService
                .isTargetControlValueEqualTo(
                  'category',
                  val => !['OTHER'].includes(val),
                )
                .bind(this),
              Validators.required,
            ),
          ],
        ],

        accountId: [entity ? entity.accountId : null],
        file: [entity ? entity.file : null],
      },
      options,
    );
  }

  extract() {
    return {
      ownerIds: this.utilsService.emptyIsNull(this.form.value.ownerIds),
      label: this.utilsService.emptyIsNull(this.form.value.label),
      document: this.utilsService.emptyIsNull(this.form.value.document),
      file: this.utilsService.emptyIsNull(this.form.value.file),
      accountId: this.utilsService.emptyIsNull(this.form.value.accountId),
      visible: true,
    };
  }
}
